    import React from 'react';
    import TopicCard from '../components/TopicCard/TopicCard';
    import styles from './Pages.module.css';

    const ListsPage: React.FC = () => {
    return (
        <div className={styles.container}>
          <h1 className={styles.title}>Linear Data</h1>
          <p className={styles.subtitle}></p>
          <div className={styles.cardContainer}>
            <TopicCard
            title='Linked List'
            description='A chain of nodes connected by pointers for flexible storage.'
            link ='/lists/linked-list'
            icon='🔗'
            />
            <TopicCard
            title='Doubly Linked List'
            description='Each node connects both forward and backward for easy traversal.'
            link ='/lists/doubly-linked-list'
            icon='↔️'
            />
            <TopicCard
            title='Stack'
            description='Stores elements in a Last-In, First-Out (LIFO) manner.'
            link ='/lists/stack'
            icon='📚'
            />
            <TopicCard
            title='Queue'
            description='Processes elements in a First-In, First-Out (FIFO) order.'
            link ='/lists/queue'
            icon='📥'
            />
            <TopicCard
            title='Ring Buffer'
            description='A circular queue that overwrites the oldest data when full.'
            link ='/lists/ring-buffer'
            icon='🔄'
            />
            <TopicCard
            title='Compare Lists'
            description='Compare performance and behavior across different list types.'
            link ='/lists/comparelist'
            icon='🏁'
            />
          </div>
        </div>
      );
    };

    export default ListsPage;
    
